'use client'

import {
  addOrRemoveRetailNewsFilterContinents,
  addOrRemoveRetailNewsFilterCountry,
  addOrRemoveRetailNewsFilterCriteria,
  addOrRemoveRetailNEwsFilterSubDivision,
} from '@/app/globalRedux/filter/retail/retailnewsFilter'
import { RootState } from '@/app/globalRedux/store'
import { useTranslation } from '@/app/i18n/client'
import Tag from '@/components/ui/Tag'
import { useDispatch, useSelector } from 'react-redux'

const RetailNewsFilterTags = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const retailNewsFilter = useSelector(
    (state: RootState) => state.retailNewsFilter
  )

  const handleRemoveCriteria = (criteria: string) => {
    dispatch(addOrRemoveRetailNewsFilterCriteria(criteria))
  }

  const handleRemoveSubDivision = (subDivision: string) => {
    dispatch(addOrRemoveRetailNEwsFilterSubDivision(subDivision))
  }

  const handleRemoveCountry = (country: any) => {
    dispatch(addOrRemoveRetailNewsFilterCountry(country))
  }

  const handleRemoveContinent = (continent: any) => {
    dispatch(addOrRemoveRetailNewsFilterContinents(continent))
  }

  const filterTags = [
    ...retailNewsFilter.retailNewsCriterias.map((criteria) => ({
      value: criteria,
      label: 'Criteria',
      callback: handleRemoveCriteria,
    })),
    ...retailNewsFilter.retailNewsFilterSubDivision.map((subDivision) => ({
      value: subDivision,
      label: 'SubDivision',
      callback: handleRemoveSubDivision,
    })),
    ...retailNewsFilter.retailNewsFilterCountry.map((country) => ({
      value: country.name,
      label: 'Country',
      callback: handleRemoveCountry,
    })),
    ...retailNewsFilter.retailNewsFilterContienent.map((continent) => ({
      value: continent.name,
      label: 'Continent',
      callback: handleRemoveContinent,
    })),
  ]

  return (
    <div className="flex flex-row gap-[2px] my-3 mobile:flex-col mobile:gap-[10px] mobile:mt-[10px]">
      {filterTags.length !== 0 && (
        <>
          <div className="flex flex-row mr-[5px] items-center">
            <p className="text-[#6f6f6f] text-sm font-medium">
              {t('Filters Applied')}
            </p>
          </div>
          <div className="flex flex-row flex-wrap gap-2 w-full max-w-[500px] items-center">
            {filterTags
              ?.slice(0, 2)
              ?.map((filter, index) => (
                <Tag
                  key={index}
                  label={` ${filter.value}`}
                  callBackFunction={() => filter.callback(filter.value)}
                />
              ))}
            {filterTags.length > 2 && (
              <div className="text-[#fff] text-sm font-medium text-orange">
                <p>{`+${filterTags.length - 2}`}</p>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  )
}

export default RetailNewsFilterTags
